import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, Label, Input, Card, CardBody,
    Container, Button, FormFeedback
} from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchFaqsEditData } from "../../store/faqs/actions";

const FaqsEdit = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(state => state.Faqs.edit);

    const [faqId, setId] = useState(id);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [categorie, setCategorie] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            dispatch(fetchFaqsEditData(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (data?.data) {
            setId(data.data.id || id);
            setTitle(data.data.title || "");
            setDescription(data.data.description || "");
            setCategorie(data.data.categorie || "");
        }
    }, [data]);

    const [validation, setValidation] = useState({
        title: null,
        description: null,
        categorie: null,
    });

    const validateFields = () => {
        let isValid = true;
        const newValidation = {};

        newValidation.title = title.trim() !== '';
        newValidation.description = description.trim() !== '';
        newValidation.categorie = categorie.trim() !== '';

        setValidation(newValidation);

        Object.values(newValidation).forEach(v => {
            if (v !== true) isValid = false;
        });

        return isValid;
    };

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;

        const formData = new FormData();
        formData.append('id', faqId);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('categorie', categorie);

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/faqs/update`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const result = await response.json();

            if (response.status === 200) {
                toast.success('Faqs updated successfully', { autoClose: 3000 });
                navigate(`/faqs`);
            } else if (response.status === 422) {
                if (result?.errors) {
                    Object.values(result.errors).forEach((errorArr) => {
                        errorArr.forEach((errMsg) => {
                            toast.error(errMsg, { autoClose: 3000 });
                        });
                    });
                } else {
                    toast.error(result?.message || 'Validation failed', { autoClose: 3000 });
                }
            } else {
                toast.error(result?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to update faqs", { autoClose: 3000 });
        }
    };

    document.title = "Edit Faqs | Moeen";

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs maintitle="Home" title="Faqs" breadcrumbItem="Edit Faqs" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            {/* Title */}
                                            <div className="mb-3">
                                                <Label>Title</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter title"
                                                    value={title}
                                                    onChange={e => setTitle(e.target.value)}
                                                    valid={validation["title"] === true}
                                                    invalid={validation["title"] !== true && validation["title"] !== null}
                                                />
                                                <FormFeedback tooltip>Title is required.</FormFeedback>
                                            </div>
                                        </Col>

                                        {/* Categorie */}
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Categorie</Label>
                                                <Input
                                                    type="select"
                                                    value={categorie}
                                                    onChange={e => setCategorie(e.target.value)}
                                                    valid={validation["categorie"] === true}
                                                    invalid={validation["categorie"] !== true && validation["categorie"] !== null}
                                                >
                                                    <option value="">Select categorie</option>
                                                    <option value="Users">Users</option>
                                                    <option value="Drivers">Drivers</option>
                                                </Input>
                                                <FormFeedback tooltip>Categorie is required.</FormFeedback>
                                            </div>
                                        </Col>

                                        <Col md="12">
                                            {/* Subtypes */}
                                            <div className="mb-3">
                                                <Label>Description</Label>
                                                <Input
                                                    type="textarea"
                                                    rows="5"
                                                    placeholder="Enter description"
                                                    value={description}
                                                    onChange={e => setDescription(e.target.value)}
                                                    valid={validation["description"] === true}
                                                    invalid={validation["description"] !== true && validation["description"] !== null}
                                                />
                                                <FormFeedback tooltip>Description is required.</FormFeedback>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="text-end">
                                            <Button type="submit" color="primary">
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Updating
                                                    </>
                                                ) : (
                                                    "Update"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FaqsEdit;
